const attributes = {
	//basic
	uniqueId: { type: 'string', default: '' },
	layout: { type: 'number', default: 1 },
	isGradientBg: { type: 'boolean', default: 0 },
	bgColor: { type: 'string', default: '#7840FF' },
	bgColor2: { type: 'string', default: '#7840FF' },
	bgImage: { type: 'object', default: {url: cta_gutenberg_locate.plugin + 'assets/images/cta_1.png', alt: 'Call to action Image', id: 0} },

	//Content
	title: { type: 'string', default: 'Flexi Addons For Elementor' },
	description: { type: 'string', default: 'Etiam convallis elementum sapien, a aliquam turpis aliquam vitae. Praesent sollicitudin felis vel mi facilisis posuere Nulla ultrices.' },
	btn_label: { type: 'string', default: 'Free trial' },
	btn_url: { type: 'string', default: '#' },
	btn_target: { type: 'boolean', default: 1 }
}
export default attributes;